import APIClient from './index';
import _ from 'lodash';

export const getLinksToCheck = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('/UrlDataAgentEvaluations/links-to-check', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getLinksToCheckCounts = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('/UrlDataAgentEvaluations/links-to-check/counts', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
